// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"4ebfd14e","474":"2fd16fda","622":"a0eb2649"}[chunkId] + ".chunk.js";
};